import { create } from "zustand";

interface StoreInterface {
  isOpen: boolean;
}

const BlankState: StoreInterface = {
  isOpen: false
};

export class NavDrawerModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  private static setState = NavDrawerModel.useState.setState;

  static get state(): StoreInterface {
    return NavDrawerModel.useState.getState();
  }

  static open(): void {
    NavDrawerModel.setState({ isOpen: true });
  }

  static close(): void {
    NavDrawerModel.setState({ isOpen: false });
  }

  static toggle(): void {
    NavDrawerModel.setState({ isOpen: !NavDrawerModel.state.isOpen });
  }
}
